import * as React from 'react';

import './SubmissionVerification.scss';

import { PortalTextCommon, Submission } from '../../Models/Api/strongbox.financialportal';

type Props = {
    submission?: Submission;
    style?: any;
    commonText?: PortalTextCommon;
};

export const SubmissionVerification: React.FC<Props> = (props): React.ReactElement => {
    const {
        submission,
        style,
        commonText,
    } = props;

    const verified = React.useMemo(() => {
        if (!submission) {
            return false;
        } else {
            return submission.isVerifiedContent;
        }

    }, [submission])

    return (
        <span
            className={`file-group-verification-status ${verified ? 'file-group-verified' : 'file-group-unverified'}`}
            style={style}
        >
            {verified ? (commonText?.verified || '') : (commonText?.unverified || '')}
        </span>
    )
}
